import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ThemeProvider } from "./theme/ThemeProvider";
import "./styles/base.css";
import { initAnalytics } from "./lib/analytics";
import { rememberAttribution } from "./lib/attribution";
import { initMetaPixel } from "./lib/metaPixel";
import { initGoogleAds } from "./lib/googleAds";
import { listenForGetAppClicks } from "./lib/getAppClicks";

rememberAttribution();
initMetaPixel();
initGoogleAds();
initAnalytics();
listenForGetAppClicks();

// The prerendered HTML carries the head tags <Seo /> rendered at build time.
// Drop them before React adds its own, or every page would have two titles.
document.head.querySelectorAll("[data-seo]").forEach((node) => node.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
